import { useState, useEffect } from "react";  
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";  
import { useToast } from "../../../common_nextgen/hooks/ToastContext";  
import getBackendUrl from "../../../environment/BackendService"; 
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import { useRBAC } from "../../../common_nextgen/hooks/RBACContext";

  
const useBenefitMaxScheduleNotes = (selectedPriceSchedules, initialIndex, currentMode) => {  
  const [notes, setNotes] = useState([]); 
  const { axios_helper_no_header } = useAxios(); 
  const [newNotes, setNewNotes] = useState([""]);  
  const [mode, setMode] = useState("view"); // 'view' or 'add'  
  const [first, setFirst] = useState(0);  
  const [rows, setRows] = useState(10);  
  const [totalRecords, setTotalRecords] = useState(0);  
  const [currentIndex, setCurrentIndex] = useState(initialIndex);  
  const toast = useToast(); 
  const { writeAccess } = useRBAC(); 
  
  const initializeProgram = async () => {  
    const page = first / rows;  
    try {  
      if (mode === 'view') {  
        const bscScheduleName = selectedPriceSchedules[currentIndex].bscScheduleName;  
        const params = {  
          bscScheduleName: bscScheduleName,  
          page: page,  
          size: rows  
        };  
        const notesResponse = await axios_helper_no_header(  
          "GET",  
          "api/bsnBenefitSchCtlNotes",  
          {},  
          params  
        );  
        if (notesResponse && notesResponse.responseData) {
            setNotes(notesResponse.responseData);
            setTotalRecords(notesResponse.responsePaginationDTO.totalRecords);
            if (writeAccess && notesResponse.responsePaginationDTO.totalRecords === 0) {
                setMode("add");
            }
        } else {
            console.error("Unexpected response structure:", notesResponse);
        }
    }
    } catch (error) {  
      console.error("Initialization failed:", error);  
    }  
  };  
  
  useEffect(() => {  
    initializeProgram();  
  }, [first, rows, currentIndex, selectedPriceSchedules, mode]);  
  
  useEffect(() => {  
    setNewNotes(Array(rows).fill(''));  
    setFirst(0);  
  }, [mode, rows]);  
  
  const handleSaveNotes = async (formData) => {  
    try {  
      const updatedNotes = formData  
      .filter((note) => (String(note).trim() !== "" && note!==undefined)) 
        .map((note) => ({  
          bscScheduleName: selectedPriceSchedules[currentIndex].bscScheduleName,  
          bsnNote: note,  
          screenNumber: "RCBSN001"  
        }));  
  
      const response = await axios_helper_no_header(  
        "POST",  
        "api/bsnBenefitSchCtlNotes",  
        updatedNotes,  
        {}  
      );  
  
      setNotes([...updatedNotes, ...notes]);  
      setNewNotes([""]);  
      setMode("view");  
    } catch (error) {  
      console.error("Save notes failed:", error);  
      toast.current.show({  
        severity: "error",  
        summary: "",  
        detail: error.message,  
        life: 3000,  
      });  
    }  
  };  
  
  const handleChangeNewNote = (index, value) => {  
    const updatedNotes = [...newNotes];  
    updatedNotes[index] = value;  
    setNewNotes(updatedNotes);  
  };  
  
  const onPageChange = (event) => {  
    setFirst(event.first);  
    setRows(event.rows);  
    setNewNotes(Array(rows).fill(''));  
  };  

  const exportAsCSV = async () => {
    let params = {  
      bscScheduleName: selectedPriceSchedules[currentIndex].bscScheduleName  
    };  
    const queryParams = new URLSearchParams({ ...params });  
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/bsnBenefitSchCtlNotes/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };
  
  return {  
    notes,  
    newNotes,  
    mode,  
    first,  
    rows,  
    totalRecords,  
    currentIndex,  
    setMode,  
    setFirst,  
    setRows,  
    setCurrentIndex,  
    handleSaveNotes,  
    handleChangeNewNote,  
    onPageChange,  
    exportAsCSV  
  };  
};  

export default useBenefitMaxScheduleNotes;